// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router";

import type { SearchStatesType } from "../types/UserFormType";
import Upload from "../component/Upload";
import {
  ErrosDisplay,
  setErrorMsg,
} from "../../global/components/ErrosDisplay";
import LoadingProgress from "../../global/components/LoadingProgress";
import { getUserInfo } from "../../global/actions/databaseActions";
import { ColorSchema } from "../../global/types/scss";
import { buttonStyles } from "../../global/components/StyledButtons";
import TileItem from "../component/TileItem";
import { getCookie } from "../../global/functions/cookies";
import LogoffButton from "../../global/components/LogoffButton";
import LivenessCheck from "../component/LivenessCheck";

import Grid from "@material-ui/core/Grid";
import GridList from "@material-ui/core/GridList";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";

class Search extends Component<*, SearchStatesType> {
  setLoadError: Function;
  setImageError: Function;
  setImg: Function;
  resetForm: Function;
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      img: null,
      loading: false,
      liveness: null,
    };
    this.setLoadError = this.setLoadError.bind(this);
    this.setImageError = this.setImageError.bind(this);
    this.setImg = this.setImg.bind(this);
    this.resetForm = this.resetForm.bind(this);
  }

  componentDidMount() {
    const accessToken = getCookie("access_token");
    if (accessToken === "") {
      this.setLoadError(
        "Access Code is not correct. Please check your Access Link."
      );
    } else if (!this.props.db.conference.active) {
      this.setLoadError(
        this.props.db.conference.display_name +
          " conference has not started yet."
      );
    } else {
      if (
        this.props.db.conference.id !== undefined &&
        this.props.db.user === undefined
      ) {
        this.props.actions.getUserInfo(
          this.props.db.conference.id,
          accessToken,
          "",
          this.checkSearchAvaiable
        );
      } else {
        this.checkSearchAvaiable();
      }
    }
  }

  checkSearchAvaiable = (): * => {
    const user = this.props.db.user;
    const isAdmin =
      user &&
      user.permissions &&
      user.permissions.indexOf("conference_admin") > -1;
    const isSearchForbid =
      !this.props.db.conference.allow_user_searching && !isAdmin;
    if (isSearchForbid) {
      this.setLoadError("You don't have authority to view this page.");
    }
  };

  setLoadError(error: string) {
    this.setErrorMessage("access_token", error);
  }

  setImageError(error: string) {
    this.setErrorMessage("image", error);
  }

  setErrorMessage(name: string, error: string) {
    if (error === "") {
      this.setState({ errors: setErrorMsg(this.state.errors, name, "", true) });
    } else {
      this.setState({ errors: setErrorMsg(this.state.errors, name, error) });
    }
  }

  setImg(img: HTMLImageElement) {
    this.setState({ img: img, loading: false });
  }

  resetForm() {
    this.setImageError("");
    this.setState({ img: null, loading: false });
  }

  setLiveness = (json: *): * => {
    this.setState({ liveness: json });
  };

  render(): React$Element<*> {
    const classes = this.props.classes;

    let tileData =
      this.state.img &&
      this.props.db.searchResults &&
      this.props.db.searchResults.map((tile, i) => {
        return <TileItem key={i} tile={tile} img={this.state.img} />;
      });
    if (
      this.state.img &&
      this.props.db.searchResults &&
      tileData.length === 0
    ) {
      tileData = <TileItem tile={null} img={null} />;
    }

    return (
      <div>
        <div className="top-banner">
          <ErrosDisplay errors={this.state.errors} form="user" />
        </div>
        <Typography
          variant="subheading"
          className="form-text hint-margin-bottom"
          style={{ color: ColorSchema("primary") }}
        ></Typography>

        {Object.keys(this.state.errors).length === 0 && (
          <Grid container spacing={8}>
            {(this.props.db.user && this.props.db.conference.active && (
              <Grid item xs={12}>
                {(this.state.img === null && (
                  <Upload
                    setImageError={this.setImageError}
                    setImg={this.setImg}
                    isSearch={true}
                    setLiveness={this.setLiveness}
                  />
                )) ||
                  null}
              </Grid>
            )) || (
              <div className="form-text">
                <LoadingProgress size={100} />
              </div>
            )}
            {/* {this.state.img && <LivenessCheck liveness={this.state.liveness} />} */}
            {tileData && (
              <Grid item xs={12}>
                <Typography
                  variant="subheading"
                  className="form-text"
                  style={{ color: ColorSchema("primary") }}
                >
                  Search Results
                </Typography>
                <GridList className="grid-root">{tileData}</GridList>
              </Grid>
            )}
            {this.state.img && (
              <Grid item xs={12}>
                <Button
                  color="primary"
                  variant="raised"
                  type="submit"
                  id="submitBtn"
                  className={classes.primaryBtn + " top-margin-30"}
                  style={{ width: "60%", margin: "0 20%" }}
                  onClick={this.resetForm}
                >
                  Search Another Photo
                </Button>
              </Grid>
            )}
            <Grid item xs={12} className="top-margin-30">
              <Typography variant="body1" className="form-text">
                <Link
                  to={"/" + this.props.params.conference + "/profile"}
                  className="form-link-green"
                  style={{ color: ColorSchema("primary") }}
                >
                  Back to My Profile
                </Link>
              </Typography>
            </Grid>
          </Grid>
        )}
        <LogoffButton />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { db: state.forensic.db };
}

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators({ getUserInfo }, dispatch) };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(buttonStyles)(Search));



// WEBPACK FOOTER //
// ./src/conference/views/Search.js